/** Paleta alinhada com `CATEGORY_COLOR_PALETTE` no backend. */
export const CATEGORY_COLOR_PALETTE = [
  '#7C9E6F',
  '#D4A574',
  '#6B8FA8',
  '#C97B84',
  '#9B8BB8',
  '#E8A54B',
  '#5BA3A3',
  '#B87DA6',
  '#8B9A6B',
  '#D97C5E',
  '#6C8EBF',
  '#A67C52',
];

export const DEFAULT_CATEGORY_COLOR = CATEGORY_COLOR_PALETTE[0];
